module.exports = __webpack_public_path__ + "img/chouqian-start-button-image.091e7a7b.png";